import { confirmPopup } from 'primereact/confirmpopup';

export default confirmPopup;
